<template>
  <div class="uk-flex uk-flex-center" uk-grid>

    <ErrorModal id="AddCreditErrorModal" message="There was an error redirecting you to paypal. Please try again or contact support." />

    <div class="uk-width-1-1">
      <h2 class="uk-text-center uk-margin-medium-top">Add Account Credit</h2>
    </div>

    <div class="uk-width-1-1@s uk-width-xlarge@m">
      <Card class="uk-border-rounded uk-box-shadow-small">
        <template v-slot:header>
          <div uk-grid>
            <div class="uk-width-1-1 uk-margin-small-top uk-margin-small-bottom uk-text-center">
              <h3>
                Current Balance: <br />
              </h3>
              <h3 class="uk-h1 uk-margin-top">
                {{ account_balance | formatCurrency }}
              </h3>
            </div>
          </div>
        </template>

        <template v-slot:body>
          <div class="uk-flex-center" uk-grid>
            <div class="uk-width-1-1">
              <form class="uk-form uk-grid-row-small uk-grid-small uk-flex uk-flex-center" uk-grid>

                <div class="uk-width-1-1 uk-text-center uk-margin-medium-top">
                  <h4 class="uk-text-emphasis">How much do you want to add?</h4>
                </div>

                <div class="uk-width-1-2@l uk-margin-medium">
                  <div class="uk-form-controls">
                    <div class="uk-inline ">
                      <span class="uk-form-icon">$</span>
                      <input class="uk-input uk-form-large" type="text" name="amount" pattern="[0-9]*" v-mask="'####'" v-model="amount" placeholder="20" required />
                    </div>
                  </div>
                </div>

                <div class="uk-width-1-1@s uk-margin-top">
                  <label><input class="uk-checkbox" type="checkbox" required> I have read and agree to BitAccel's Terms of Service and Privacy Policy</label>
                </div>

              </form>
            </div>
          </div>
        </template>

        <template v-slot:footer>
          <div class="uk-flex uk-flex-center" uk-grid>
            <div class="uk-width-1-2@l uk-width-1-2@s">
              <BitButton size="large" type="submit" @click.native="submit_add_account_credit()" v-if="!spin">
                <img src="@/assets/images/paypal-icon.svg" height="30" style="margin-left: -15px;" uk-svg />
                Add Credit
              </BitButton>
              <BitButton v-if="spin" size="large" disabled><div uk-spinner></div></BitButton>
            </div>
            <div class="uk-width-1-1">
              <p class="uk-text-meta">You will be directed to Paypal to finish your payment. Paypal may be blocked by your browser's pop-up blocker. To fix this, please disable your browser's pop-up blocker for this page, then refresh.</p>
            </div>
          </div>
        </template>
      </Card>
    </div>

  </div>
</template>

<script>
import BitButton from '@/components/common/button.vue';
import Card from '@/components/common/card.vue';
import ErrorModal from '@/components/portal/errormodal.vue';

import { mapActions, mapState } from "vuex";

import UIkit from 'uikit';

export default {
  name: 'AccountCredit',
  components: {
    BitButton,
    Card,
    ErrorModal
  },
  data() {
    return {
      spin: false,
      amount: 10
    }
  },
  computed: {
    ...mapState('credit', ['account_balance']),
  },
  created() {
    this.GET_ACCOUNT_CREDIT();
  },
  methods: {
    ...mapActions('credit', ['ADD_ACCOUNT_CREDIT_VIA_PAYPAL', 'GET_ACCOUNT_CREDIT']),
    submit_add_account_credit() {
      this.spin = true;
      this.ADD_ACCOUNT_CREDIT_VIA_PAYPAL(this.amount)
        .then( (paypal_response) => {
          this.spin = false;
          window.location.href = paypal_response.data.url; //send them to paypal
        }).catch( () => {
          this.spin = false;
          UIkit.modal('#AddCreditErrorModal').show();
        })
    }
  }
}
</script>

<style scoped lang="less">
@import "../../../assets/less/theme.less";

.uk-inline {
  width: 100%;
}
</style>
